import useTimeoutFn from './useTimeoutFn';
import useUpdate from './useUpdate';
export default function useTimeout(ms) {
    if (ms === void 0) { ms = 0; }
    var update = useUpdate();
    return useTimeoutFn(update, ms);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useTimeout.js
// module id = ./node_modules/react-use/esm/useTimeout.js
// module chunks = main